// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/big-logo-common.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_main__x4U4z {
  width: 100%;
  display: flex;
  gap: 30px;
}

.Contact_content__V-L7D {
  width: 50%;
  font-size: 12px;
  line-height: 20px;
}

.Contact_head__AiDG0 {
  padding-top: 10px;
}

.Contact_textarea__K5X61 {
  height: 296px;
}

.Contact_button__jU4Vh {
  max-width: 100%;
  display: block;
  margin: 35px auto 0 auto;
  padding: 0 60px;
  border-radius: 24px;
  background-color: #00007A;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.Contact_button__jU4Vh:disabled {
  background-color: #E0E0E3;
}

.Contact_cover__pzJGc {
  width: calc(50% - 12px);
  display: inline-block;
  background: #f5f5fe url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center bottom no-repeat;
  background-size: 100% auto;
  border-radius: 8px;
}

.Contact_success-message__MwdZ3 {
  height: 40px;
  margin: 20px 0;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/pages/Contact/Contact.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,WAAA;EACA,aAAA;EACA,SAAA;AAkBJ;;AAfA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAkBJ;;AAfA;EACI,iBAAA;AAkBJ;;AAfA;EACI,aAAA;AAkBJ;;AAfA;EACI,eAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBCpBI;EDqBJ,uBAAA;EACA,gBAAA;EACA,mBAAA;AAkBJ;AAhBI;EACI,yBC7BA;AD+CR;;AAdA;EACI,uBAAA;EACA,qBAAA;EACA,mFAAA;EACA,0BAAA;EACA,kBAAA;AAiBJ;;AAdA;EACI,YAAA;EACA,cAAA;EACA,cAAA;AAiBJ","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.main{\n    width: 100%;\n    display: flex;\n    gap: 30px;\n}\n\n.content{\n    width: 50%;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.head{\n    padding-top: 10px;\n}\n\n.textarea{\n    height: 296px;\n}\n\n.button{\n    max-width: 100%;\n    display: block;\n    margin: 35px auto 0 auto;\n    padding: 0 60px;\n    border-radius: 24px;\n    background-color: colors.$blue1;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n\n    &:disabled{\n        background-color: colors.$grey4;\n    }\n}\n\n.cover{\n    width: calc(50% - 12px);\n    display: inline-block;\n    background: #f5f5fe url(../../../../assets/big-logo-common.svg) center bottom no-repeat;\n    background-size: 100% auto;\n    border-radius: 8px;\n}\n\n.success-message{\n    height: 40px;\n    margin: 20px 0;\n    line-height: 1;\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"main": `Contact_main__x4U4z`,
	"content": `Contact_content__V-L7D`,
	"head": `Contact_head__AiDG0`,
	"textarea": `Contact_textarea__K5X61`,
	"button": `Contact_button__jU4Vh`,
	"cover": `Contact_cover__pzJGc`,
	"success-message": `Contact_success-message__MwdZ3`
};
export default ___CSS_LOADER_EXPORT___;
